module.exports = __webpack_public_path__ + "img/big_1_62.fbfc8d2e.png";